import { render, staticRenderFns } from "./FeedbackRating.vue?vue&type=template&id=9f7cc772&scoped=true&"
import script from "./FeedbackRating.vue?vue&type=script&lang=ts&"
export * from "./FeedbackRating.vue?vue&type=script&lang=ts&"
import style0 from "./FeedbackRating.vue?vue&type=style&index=0&id=9f7cc772&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f7cc772",
  null
  
)

export default component.exports